var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rank-info-icon" },
    [
      _vm.data.action === "raise"
        ? _c(
            "svg",
            {
              attrs: {
                id: `rank-info-icon-${_vm.iconKey}`,
                width: "10",
                height: "12",
                viewBox: "0 0 10 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M5 11V1M5 1L9 5M5 1L1 5",
                  stroke: "#12C971",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.data.action === "reduce"
        ? _c(
            "svg",
            {
              attrs: {
                id: `rank-info-icon-${_vm.iconKey}`,
                width: "10",
                height: "12",
                viewBox: "0 0 10 12",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M5 1V11M5 11L9 7M5 11L1 7",
                  stroke: "#FF238D",
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          )
        : _vm._e(),
      _c(
        "b-popover",
        {
          attrs: {
            triggers: _vm.getPopoverType(),
            placement: "bottom",
            target: `rank-info-icon-${_vm.iconKey}`,
          },
        },
        [_vm._v(" " + _vm._s(_vm.recommendationText) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }